import { useRef, useState } from "react";
import { toast } from "react-toastify";
import { Button, Modal, ModalBody } from "reactstrap";
import { Icon } from "../../components/Component";
import { FILE } from "../../helper/api";
import { getToken } from "../../helper/auth";
const UpsertLocationDistance = ({ reload }) => {
  const [view, setView] = useState({
    upload: false
  });
  const uploadRef = useRef()
  const [uploadFile, setUploadFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleDropChange = (acceptedFiles) => {
    if (acceptedFiles.length === 0) {
      return;
    }
    setUploadFile(Object.assign(acceptedFiles[0], {
      preview: URL.createObjectURL(acceptedFiles[0]),
    }));
  };

  const exportTemplate = () => {

    const params = new URLSearchParams({
      token: getToken(),
    })
    const url = `${process.env.REACT_APP_API_URL}/api/v1/location-distance/export-template?${params.toString()}`;
    window.open(url, '_blank')
  };

  const onFormCancel = () => {
    setView({ upload: false, });
  };

  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  const confirmUpload = () => {
    setLoading(true);
    const formData = new FormData();
    formData.append('file', uploadFile);
    FILE('/location-distance/rebulk-create', formData, {}, true)
      .then(() => {
        setUploadFile(null);
        toast.success('Cập nhật thành công');
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        uploadRef.current.value = null;
        setUploadFile(null);
        setLoading(false);
        onFormCancel();
        if (reload) {
          reload();
        }
      })
  }
  return <div>
    <Button
      className="btn-primary"
      color="primary"
      onClick={exportTemplate}
    >
      <Icon name="plus"></Icon>
      <span>Mẫu sửa khoảng cách</span>
    </Button>

    <Button
      className="btn-primary ml-2"
      color="primary"
      onClick={() => toggle('upload')}
    >
      <Icon name="plus"></Icon>
      <span>Tải bản sửa khoảng cách</span>
    </Button>
    <Modal isOpen={view.upload} toggle={() => onFormCancel()}>
      <ModalBody className="modal-body-lg text-center">
        <div className="nk-modal">
          <h5 className="nk-modal-title">
            Vui lòng kiểm tra kỹ
          </h5>
          <div>Quá trình nhập dữ liệu có thể tốn nhièu thời gian. Vui lòng đợi và không tắt trình duyệt</div>
          <div className="mt-2">
            <input type="file" className="d-none" accept=".xlsx" ref={uploadRef} onChange={(e) => {
              handleDropChange(e.target.files)
            }} />
            <Button disabled={loading} className={'ml-2'} color="secondary" onClick={() => {
              uploadRef.current.click();
            }}>Bấm chọn tệp tin tải lên</Button>
            <div className="mt-2">
              {uploadFile && <span className="ml-2">Bạn đã chọn tệp: {uploadFile.name}</span>}

            </div>
          </div>
          <div>
          </div>
        </div>
        <div className="nk-modal-action mt-5 d-flex justify-content-around">
          <Button
            color="light"
            size="lg"
            className="btn-mw mr-5"
            onClick={() => onFormCancel()}
            disabled={!uploadFile || loading}
          >
            Huỷ bỏ
          </Button>
          <Button
            color="primary"
            size="lg"
            className="btn-mw"
            disabled={!uploadFile || loading}
            onClick={(ev) => {
              ev.preventDefault();
              confirmUpload();
            }}
          >
            Xác nhận
          </Button>
        </div>
      </ModalBody>
    </Modal>
  </div >
}

export default UpsertLocationDistance;